export const PAYMENT_METHODS_OPTIONS = [
  { label: "PIX", value: "feev_pix", icon: "pix" },
  { label: "Cartão de Crédito", value: "braspag_cartao", icon: "credit-card" },
  { label: "Boleto", value: "feev_boleto", icon: "barcode" },
] as const;
